import { isEmpty } from '@core/utils/index'

export const required = value => {
  if (value === null || value === undefined || value === '') {
    return '这是必填项'
  }

  if (Array.isArray(value) && value.length === 0) {
    return '这是必填项'
  }

  return true
}

export const checkSecond = value => {
  if (value === null || value === undefined || value === '') {
    return '这是必填项'
  }

  if (value > 59 || value < 0) {
    return '请输入0~59之间的整数'
  }

  return true
}
export const checkHour = value => {
  if (value === null || value === undefined || value === '') {
    return '这是必填项'
  }

  if (value > 20 || value < 0) {
    return '请输入0~20之间的整数'
  }

  return true
}
export const checkMinute = value => {
  if (value === null || value === undefined || value === '') {
    return '这是必填项'
  }

  if (value > 59 || value < 0) {
    return '请输入0~59之间的整数'
  }

  return true
}

export const requiredNonSpace = value => {
  if (value) {
    if (value.trim() === '') {
      return false // 输入值为空或只包含空格，校验失败
    }

    return true // 输入值有效，校验通过
  }

  return false
}

export const booleanValidator = value => (value === 0 || value === 1 ? true : '这是必填项')

export const isNotNullValidator = value => (value === '' || value === null ? '这是必填项' : true)

export const emailValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (Array.isArray(value)) {
    return value.every(val => re.test(String(val)))
  }

  return re.test(String(value)) || 'The Email field must be a valid email'
}

export const passwordValidator = password => {
  /* eslint-disable no-useless-escape */
  // const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  const regExp = /(?=.*\d)(?=.*[a-zA-Z])([!@#$%&*()]?).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)

  return (
    // eslint-disable-next-line operator-linebreak
    validPassword || '密码最少要包含1个数字，1个大写字母或小写字母，最少8位'

  // 'Field must contain at least one uppercase, lowercase, special character and digit with min 8 chars'
  )
}

export const confirmedValidator = (value, target) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  value === target || 'The Confirm Password field confirmation does not match'

export const between = (value, min, max) => () => {
  const valueAsNumber = Number(value)

  return (Number(min) <= valueAsNumber && Number(max) >= valueAsNumber) || `Enter number between ${min} and ${max}`
}

// 整数
export const integerValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  if (Array.isArray(value)) {
    return value.every(val => /^-?[0-9]+$/.test(String(val)))
  }

  return /^-?[0-9]+$/.test(String(value)) || 'This field must be an integer'
}

// 正整数
export const isIntegerValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  if (Array.isArray(value)) {
    return value.every(val => /^[0-9]*[1-9][0-9]*$/.test(String(val)))
  }

  return /^[0-9]*[1-9][0-9]*$/.test(String(value)) || '只能输入正整数'
}

export const regexValidator = (value, regex) => {
  if (isEmpty(value)) {
    return true
  }

  let regeX = regex
  if (typeof regeX === 'string') {
    regeX = new RegExp(regeX)
  }

  if (Array.isArray(value)) {
    return value.every(val => regexValidator(val, { regeX }))
  }

  return regeX.test(String(value)) || 'The Regex field format is invalid'
}

export const alphaValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // const valueAsString = String(value)

  return /^[A-Z]*$/i.test(String(value)) || 'The Alpha field may only contain alphabetic characters'
}

export const urlValidator = value => {
  if (value === undefined || value === null || value.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/

  return re.test(value) || 'URL is invalid'
}

export const lengthValidator = (value, length) => {
  if (isEmpty(value)) {
    return true
  }

  return value.length === length || `The Min Character field must be at least ${length} characters`
}
export const alphaDashValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  const valueAsString = String(value)

  return /^[0-9A-Z_-]*$/i.test(valueAsString) || 'All Character is not valid'
}

export const specialCharValidator = item => /[`[\]]/im.test(item)

export const emptyValidator = item => item === '' || typeof item === 'undefined' || item === null

export const enValidator = item => /^\w+$/.test(item) || '必填，且不能有除英文数字下划线外的符号'

export const positiveValidator = value => value > 0 || '必填，且必须大于0'

export const notNegativeValidator = value => value >= 0 || '必填，且大于等于0'

export const workTimeValidator = value => {
  if (!value) return '请填写正确的时间格式'
  const hours = parseInt(value.split(':')[0], 10)
  const minutes = parseInt(value.split(':')[1], 10)
  const allowHours = [9, 10, 11, 14, 15, 16, 17]
  if (hours === 13) return minutes < 30 ? '请填写工作时间' : true
  if (hours === 18) return minutes <= 30 ? true : '请填写工作时间'
  if (allowHours.includes(hours)) return true

  return '请填写工作时间'
}

/**
 * 正整数 1-5000
 * @param {Number} value
 * @returns boolean
 */
export const validateInput = value => {
  // 确保输入不为空
  if (!value) {
    return false
  }

  // 使用正则表达式检查是否为整数
  const integerPattern = /^\d+$/
  if (!integerPattern.test(value)) {
    return false
  }

  // 将输入转换为整数
  const number = parseInt(value, 10)

  // 确保输入在范围内
  return number >= 1 && number <= 5000
}
